var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9986 4.57141C22.3104 4.57141 27.4272 9.68816 27.4272 16C27.4272 22.3118 22.3104 27.4286 15.9986 27.4286C9.68675 27.4286 4.57 22.3118 4.57 16C4.57 9.68816 9.68675 4.57141 15.9986 4.57141ZM15.9986 18.2857C13.218 18.2857 10.5963 19.5522 8.86463 21.7143C10.5402 23.8034 13.1122 25.1429 15.9986 25.1429C18.8844 25.1429 21.4546 23.8026 23.1303 21.7143C21.3986 19.5529 18.7787 18.2857 15.9986 18.2857ZM15.9986 9.14284C14.105 9.14284 12.57 10.6779 12.57 12.5714C12.57 14.465 14.105 16 15.9986 16C17.8921 16 19.4272 14.465 19.4272 12.5714C19.4272 10.6779 17.8921 9.14284 15.9986 9.14284Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholderIcon);
export default __webpack_public_path__ + "static/media/avatar-placeholder-icon.9ce708efede6dee1c4551c70092ba6d8.svg";
export { ForwardRef as ReactComponent };